import React, {
  CSSProperties, FC,
} from 'react';

const Row = React.forwardRef<any, Props>((({
  children,
  style,
  onClick,
}, ref) => {
  return (
    <div
      ref={ref}
      style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', ...style }}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      {children}
    </div>
  );
}));

export interface Props {
  children: any;
  style?: CSSProperties
  onClick?: () => void;
}

export default Row;
